import { action, computed, observable } from 'mobx';
import { setter, toggle } from 'mobx-decorators';
import constants from 'Constants';
import ExtendedStore from './ExtendedStore';
import MinimalStore from './MinimalStore';
import { deserializeWithMappers, setFieldValues } from 'stores/Utils';



class LauncherStore {

  @setter @toggle @observable display;
  @setter @observable variant;
  @setter @observable extended;
  @setter @observable minimal;

  static create(data={}) {
    const instance = new LauncherStore();
    setFieldValues(instance, data);
    return instance;
  }

  static getDefaults() {
    return {
      "display": false,
      "variant": "",
      "extended": new ExtendedStore(),
      "minimal": new MinimalStore(),
    };
  }

  constructor(defaults=LauncherStore.getDefaults()) {
    setFieldValues(this, defaults);
  }

  @action reset(defaults=LauncherStore.getDefaults()) {
    setFieldValues(this, defaults);
  }

  getDeserializeMappers() {
    return [
      {"field": "display"},
      {"field": "variant"},
      {"field": "extended", "type": constants.DESERIALIZE_TYPE_OBJECT, "cls": ExtendedStore},
      {"field": "minimal", "type": constants.DESERIALIZE_TYPE_OBJECT, "cls": MinimalStore},
    ];
  }

  @action deserialize(data) {
    deserializeWithMappers(this, this.getDeserializeMappers(), data);
  }

  @action setFieldValue(field, value) {
    this[field] = value;
  }

  @computed get isExtendedVariant() {
    return this.variant === constants.REPERKS_LAUNCHER_VARIANT_EXTENDED;
  }

  @computed get isMinimalVariant() {
    return this.variant === constants.REPERKS_LAUNCHER_VARIANT_MINIMAL;
  }
}

export default LauncherStore;


